import React from "react";
import {
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
  FaRegCopyright,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { scrollToTop } from "../../utils/helper";

const Footer = () => {
  return (
    <>
      {/* ================= Main Footer ================= */}
      <div className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
          <div className="flex flex-col lg:flex-row justify-between gap-10 lg:gap-16">

            {/* ================= Brand & Description ================= */}
            <div className="space-y-4 lg:max-w-xs">
              <h2 className="text-xl font-bold text-white">ConceptsByShrayansh</h2>
              <p className="text-sm text-gray-400 leading-relaxed">
                Building developers with strong fundamentals. Learn LLD, HLD, Java, Spring Boot, and crack your dream tech interviews.
              </p>
              <div className="flex gap-3 pt-2">
                <a
                  href="https://www.youtube.com/@ConceptAndCodingByShrayansh"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  className="bg-gray-800 hover:bg-red-600 p-2 rounded-full transition"
                >
                  <FaYoutube size={16} />
                </a>
                <a
                  href="https://www.linkedin.com/company/conceptandcodingbyshrayansh"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="bg-gray-800 hover:bg-blue-600 p-2 rounded-full transition"
                >
                  <FaLinkedinIn size={16} />
                </a>
                <a
                  href="https://www.instagram.com/concepts_by_shrayansh/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="bg-gray-800 hover:bg-pink-600 p-2 rounded-full transition"
                >
                  <FaInstagram size={16} />
                </a>
              </div>
            </div>

            {/* ================= Quick Links ================= */}
            <div className="space-y-4">
              <h3 className="text-base font-semibold text-white">Quick Links</h3>
              <ul className="space-y-2 text-sm text-gray-400">
                <li onClick={scrollToTop}>
                  <Link to="/" className="hover:text-blue-400 transition">Home</Link>
                </li>
                <li onClick={scrollToTop}>
                  <Link to="/about" className="hover:text-blue-400 transition">About Us</Link>
                </li>
                <li onClick={scrollToTop}>
                  <Link to="/TermsConditionsPage" className="hover:text-blue-400 transition">Terms & Conditions</Link>
                </li>
                <li onClick={scrollToTop}>
                  <Link to="/PrivacyPolicyPage" className="hover:text-blue-400 transition">Privacy Policy</Link>
                </li>
                <li onClick={scrollToTop}>
                  <Link to="/RefundPolicyPage" className="hover:text-blue-400 transition">Refund Policy</Link>
                </li>
              </ul>
            </div>

            {/* ================= Contact ================= */}
            <div className="space-y-4">
              <h3 className="text-base font-semibold text-white">Get In Touch</h3>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>
                  <a href="mailto:support@conceptsbyshrayansh.in" className="hover:text-blue-400 transition">
                    &#128231; support@conceptsbyshrayansh.in
                  </a>
                </li>
                <li className="text-gray-500">
                  &#128205; Jaipur, Rajasthan, India
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* ================= Bottom Bar ================= */}
      <div className="bg-gray-950 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-400">
          <div className="flex items-center gap-1">
            <FaRegCopyright size={12} />
            <span>{new Date().getFullYear()} ConceptsByShrayansh. All rights reserved.</span>
          </div>
          <div className="text-gray-500">
            Made with &#10084; by Shrayansh
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;